import stableStringify from './stableStringify';
export default function memoize(fn, resolver = stableStringify) {
    const cache = Object.create(null);
    return (...args)=>{
        const key = resolver(args);
        if (!(key in cache)) {
            cache[key] = fn(...args);
        }
        return cache[key];
    };
}

//# sourceMappingURL=memoize.js.map